import { parseDialogParams } from '../../lib/dialog';
import { parseSearchParams } from '../../lib/url';
import { loadCountryOptions } from '../../queries/form-data';
import { loadCompanyItems, loadItemCategories, loadItemSubcategories, loadRewardRedemption, loadRewardRedemptions } from '../../queries/rewards';
import { createHistoryDetailParamParser, createIndexParamParser, formatIndexParams, getDefaultCategoryKey } from './utils';

export const loadRewardsHistory = async ({ request }: { request: Request }) => {
	const searchParams = new URL(request.url).searchParams;
	const params = parseSearchParams(searchParams, ...createHistoryDetailParamParser());
	const dialog = parseDialogParams(searchParams, 'redemption');

	const queries: Promise<any>[] = [
		loadRewardRedemptions({
			page_number: params.page,
			sort_by: params.sortBy,
			sort_direction: params.sortDirection,
		}),
	];

	if (dialog.isOpen && dialog.params.rewardId) {
		queries.push(loadRewardRedemption(dialog.params.rewardId));
	}

	return Promise.all(queries);
};

export const loadRewardsIndex = async ({ request }: { request: Request }) => {
	const [categories, subCategories] = await Promise.all([loadItemCategories(), loadItemSubcategories(), loadCountryOptions()]);
	const defaultCategoryKey = getDefaultCategoryKey(categories);

	const params = parseSearchParams(new URL(request.url).searchParams, ...createIndexParamParser({ defaultCategoryKey, subCategories }));

	return loadCompanyItems(formatIndexParams(params, categories));
};
